// src/AdminDashboard/components/MultiStepGameForm/steps/SuccessStep.js
import React from "react";

const SuccessStep = ({ formData, updateFormData }) => {
  return (
    <div className="step-content">
      <div className="form-group">
        <label>SUCCESS MESSAGE</label>
        <input
          type="text"
          value={formData.successMessage}
          onChange={(e) => updateFormData("successMessage", e.target.value)}
          placeholder="Congratulations, you got it!"
          className="success-message-input"
        />
      </div>

      <div className="form-group">
        <label>REDIRECT BUTTON TEXT</label>
        <input
          type="text"
          value={formData.redirectButtonText}
          onChange={(e) => updateFormData("redirectButtonText", e.target.value)}
          placeholder="Click to enter for a chance to win!"
          className="button-text-input"
        />
      </div>

      <div className="form-group">
        <label>REDIRECT BUTTON LINK</label>
        <input
          type="url"
          value={formData.redirectButtonLink}
          onChange={(e) => updateFormData("redirectButtonLink", e.target.value)}
          placeholder="https://www.blueprintnyc.com/"
          className="button-link-input"
        />
      </div>

      <div className="form-group">
        <label>REDIRECT BUTTON COLOR</label>
        <div className="color-input-group">
          <input
            type="color"
            value={formData.redirectButtonColor}
            onChange={(e) =>
              updateFormData("redirectButtonColor", e.target.value)
            }
            className="color-picker"
          />
          <input
            type="text"
            value={formData.redirectButtonColor}
            onChange={(e) =>
              updateFormData("redirectButtonColor", e.target.value.trim())
            }
            onBlur={(e) =>
              updateFormData(
                "redirectButtonColor",
                (() => {
                  const v = String(e.target.value || "").trim();
                  if (/^#[0-9a-fA-F]{6}$/.test(v)) return v;
                  if (/^[0-9a-fA-F]{6}$/.test(v)) return `#${v}`;
                  const m3 = v.match(
                    /^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])$/
                  );
                  if (m3)
                    return `#${m3[1]}${m3[1]}${m3[2]}${m3[2]}${m3[3]}${m3[3]}`;
                  return v;
                })()
              )
            }
            placeholder="#DE183B"
            className="hex-input"
          />
        </div>
        <small className="field-note">*Hex Code</small>
      </div>
    </div>
  );
};

export default SuccessStep;
